import { Drawer } from '@mui/material';
import Box from '@mui/material/Box';
import Toolbar from '@mui/material/Toolbar';
import { useState } from 'react';
import { Outlet } from 'react-router-dom';

import useDeviceType from '../DeviceType';

import { AppBar } from './AppBar';
import { AppDrawer, AppDrawerProps } from './AppDrawer';
import { drawerWidth } from './utils';

interface MainFrameProps extends AppDrawerProps {
  logo: JSX.Element;
}

export default function MainFrame(props: MainFrameProps) {
  const [isOpen, setIsOpen] = useState(false);
  const { mobil, laptop } = useDeviceType();
  return (
    <Box
      sx={{
        display: 'flex',
        minHeight: '100vh',
        maxWidth: '100vw',
      }}
    >
      <AppBar logo={props.logo} />
      <div onClick={() => setIsOpen(!isOpen)}>
        {isOpen && mobil && <AppDrawer {...props} />}{' '}
        {!isOpen && mobil && (
          <Drawer
            variant="permanent"
            sx={{
              width: 70,
              flexShrink: 0,
              [`& .MuiDrawer-paper`]: { width: 70, boxSizing: 'border-box' },
            }}
          >
            <Box sx={{ overflow: 'auto', mt: 9, p: 2 }}>
              <img
                src="/favicon.ico"
                alt="Menu"
                style={{ width: '100%', maxWidth: '300px', borderRadius: '8px' }}
              />
              <div>Menu</div>
            </Box>
          </Drawer>
        )}
        {laptop && <AppDrawer {...props} />}
      </div>
      <Box
        component="main"
        sx={{
          flexGrow: 1,
          paddingLeft: 3,
          paddingRight: 3,
          paddingTop: 3,
          background: 'grey.50',
          width: window.innerWidth - drawerWidth,
        }}
      >
        <Toolbar />
        <Outlet />
      </Box>
    </Box>
  );
}
